import React from "react";
import { Helmet } from "react-helmet";
import CardMenu from "../cardMenu";
import SettingsList from "./settingsLists";
import CardEditHeader from "../cardHeader";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";


const CardSettings = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Card Settings</title></Helmet>
            <CardEditHeader />
            <div className="sidebar-with-content ds-flex">
                <CardMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <SettingsList />
                </div>
            </div>
        </div>
        
    );
}

export default CardSettings;
